import { PqtConfig, PqtGroupType, PqtMeasurementValueType, PqtProduct } from '../backend/backendapi';

export function productNumber(product: PqtProduct, groups: PqtGroupType[]): string {
  let group = groups.find(e => e.id === product.groupId);

  return group?.name + '-' + product.itemNo;
}

export function getValue(value: string, type: PqtMeasurementValueType): string | number {
  switch (type) {
    case PqtMeasurementValueType.Float:
      return parseFloat(value);
    case PqtMeasurementValueType.String:
    default:
      return value;
  }
}

export function formatValue(value: number | string | null | undefined, config: PqtConfig): string {
  if (value === null || value == undefined) {
    return '';
  } else if (typeof value === 'number') {
    return value.toFixed(config.digitsOfPrecision);
  }
  return value;
}